export default {
    'message': 'Jeśli uważasz, że to ważny problem - napisz do nas na adres <a class="link-default" href="mailto:{mail}">{mail}</a>',
    'page-not-found': 'Oops! Żądana strona nie została odnaleziona.'
}
